(function () {
  'use strict';

  var hero = document.querySelector('[data-flowbam-hero-duo]');
  if (!hero) return;

  function createSlide(number) {
    var media = hero.querySelector('[data-flowbam-hero-media="' + number + '"]');
    return {
      number: number,
      media: media,
      image: media && media.querySelector('img'),
      ready: number === 1,
      loading: false
    };
  }

  var slides = [createSlide(1), createSlide(2), createSlide(3)];
  var previousButton = hero.querySelector('[data-flowbam-hero-previous]');
  var nextButton = hero.querySelector('[data-flowbam-hero-next]');
  var dots = hero.querySelectorAll('[data-flowbam-hero-dot]');
  var copyPanels = hero.querySelectorAll('[data-flowbam-hero-copy]');
  var cta = hero.querySelector('[data-flowbam-hero-action]');
  var currentSlide = 1;
  var pendingSlide = null;
  var touchStartX = 0;
  var touchStartY = 0;
  var touchTracking = false;

  if (slides.some(function (slide) { return !slide.media || !slide.image; })) return;

  function loadSlide(number) {
    var slide = slides[number - 1];
    if (!slide || slide.ready || slide.loading) return;

    slide.loading = true;
    var sources = slide.media.querySelectorAll('source[data-srcset]');
    sources.forEach(function (source) {
      source.srcset = source.getAttribute('data-srcset');
      source.sizes = source.getAttribute('data-sizes') || '100vw';
    });

    function complete() {
      slide.ready = true;
      slide.loading = false;
      if (pendingSlide && pendingSlide.number === number) {
        pendingSlide = null;
        setSlide(number);
      }
    }

    slide.image.addEventListener('load', complete, { once: true });
    slide.image.addEventListener('error', function () {
      slide.loading = false;
      if (pendingSlide && pendingSlide.number === number) pendingSlide = null;
      hero.setAttribute('data-hero-error', 'state-' + number + '-image');
    }, { once: true });

    slide.image.srcset = slide.image.getAttribute('data-srcset');
    slide.image.sizes = slide.image.getAttribute('data-sizes') || '100vw';
    slide.image.src = slide.image.getAttribute('data-src');

    if (slide.image.complete && slide.image.currentSrc && slide.image.naturalWidth > 0) complete();
  }

  function syncState(number) {
    hero.setAttribute('data-flowbam-hero-state', String(number));

    slides.forEach(function (slide) {
      slide.media.setAttribute('aria-hidden', String(slide.number !== number));
    });
    copyPanels.forEach(function (panel) {
      panel.setAttribute('aria-hidden', String(Number(panel.getAttribute('data-flowbam-hero-copy')) !== number));
    });

    if (previousButton) previousButton.hidden = number === 1;
    if (nextButton) nextButton.hidden = number === slides.length;

    if (cta) {
      var showCta = number === 1;
      cta.hidden = !showCta;
      cta.setAttribute('aria-hidden', String(!showCta));
      cta.tabIndex = showCta ? 0 : -1;
    }

    dots.forEach(function (dot) {
      var isActive = Number(dot.getAttribute('data-flowbam-hero-dot')) === number;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', String(isActive));
      dot.tabIndex = isActive ? 0 : -1;
    });
  }

  function setSlide(number) {
    number = Math.max(1, Math.min(slides.length, number));
    var slide = slides[number - 1];
    if (!slide.ready) {
      pendingSlide = { number: number };
      loadSlide(number);
      return;
    }

    pendingSlide = null;
    currentSlide = number;
    syncState(number);
  }

  function handleTouchStart(event) {
    if (!event.touches || event.touches.length !== 1) return;
    touchStartX = event.touches[0].clientX;
    touchStartY = event.touches[0].clientY;
    touchTracking = true;
  }

  function handleTouchEnd(event) {
    if (!touchTracking || !event.changedTouches || !event.changedTouches.length) return;
    var touch = event.changedTouches[0];
    var deltaX = touch.clientX - touchStartX;
    var deltaY = touch.clientY - touchStartY;
    touchTracking = false;

    if (Math.abs(deltaX) < 44 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.4) return;
    setSlide(currentSlide + (deltaX < 0 ? 1 : -1));
  }

  function handleTouchCancel() {
    touchTracking = false;
  }

  if (previousButton) previousButton.addEventListener('click', function () {
    setSlide(currentSlide - 1);
  });

  if (nextButton) nextButton.addEventListener('click', function () {
    setSlide(currentSlide + 1);
  });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      setSlide(Number(dot.getAttribute('data-flowbam-hero-dot')) || 1);
    });
    dot.addEventListener('keydown', function (event) {
      var next = currentSlide;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next -= 1;
      else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next += 1;
      else if (event.key === 'Home') next = 1;
      else if (event.key === 'End') next = slides.length;
      else return;

      event.preventDefault();
      next = Math.max(1, Math.min(slides.length, next));
      var nextDot = hero.querySelector('[data-flowbam-hero-dot="' + next + '"]');
      if (nextDot) nextDot.focus();
      setSlide(next);
    });
  });

  hero.addEventListener('touchstart', handleTouchStart, { passive: true });
  hero.addEventListener('touchend', handleTouchEnd, { passive: true });
  hero.addEventListener('touchcancel', handleTouchCancel, { passive: true });
  syncState(1);
}());
